import { t } from '@i18n';

export default function LoadingModule() {
  return (
    <div
      css={{
        flex: 1,
        width: '100%',
        height: '100%',
        padding: '10%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 'var(--mantine-spacing-md)',
        textAlign: 'center',
      }}
    >
      <h1>{t('loadingModule.title')} </h1>
    </div>
  );
}
